// BREACH IMPACT
export const GET_BREACH_IMPACTS = '/breach-impact/query';
export const GET_BREACH_IMPACT = '/breach-impact/';
export const POST_BREACH_IMPACT = '/breach-impact/';
export const PUT_BREACH_IMPACT = '/breach-impact/';
export const DELETE_BREACH_IMPACT = '/breach-impact/';
